const GenerateValidators = e => {
  let helperText = {}
  e.inner.forEach(error => {
    helperText = {
      ...helperText,
      [error.path]: { helperText: error.message, error: true }
    }
  })
  return helperText
}
export default GenerateValidators
